import { IGnpCounter } from "./IGnpCounter";
import { TGnpCounterOptions } from "./IGnpCounterOptions";

export class GnpCounter implements IGnpCounter {
    constructor(o: TGnpCounterOptions) {
        this.element = (o.element instanceof HTMLElement
            ? o?.element
            : document.getElementById(o.element as string)) as HTMLElement;
        this.min = o?.min || Number(this.element.dataset.min || "1000000");
        this.max = o?.max || Number(this.element.dataset.max || "25000000");
        this.step = o?.step || Number(this.element.dataset.step || "1");
        this.transitionTime = o?.transitionTime || Number(this.element.dataset.transition_time || "2500");
        this.prefix = o?.prefix || this.element?.dataset?.prefix || "";
        this.suffix = o?.suffix || this.element?.dataset?.suffix || "";
        this.number_format = o?.number_format || this.element.dataset.number_format || "";
        this.delay_until_view = Boolean(o?.delay_until_view || this.element.dataset.delay_until_view || false);
        this.currentValue = this.min;
        this.format_as_currency = o?.format_as_currency !== undefined
            ? o.format_as_currency
            : Boolean(this.element.dataset.format_as_currency);
    
        this.step = Math.ceil((this.max-this.min) / (this.transitionTime / 5));

        this.initialize();
    }

    transform = () => {
        if (this.currentValue < this.max) {
            let newValue = this.currentValue + this.step;
            this.currentValue = newValue > this.max ? this.max : newValue;
            this.setText();
        } else {
            window.clearInterval(this.interval);
        }
    };
    setText = () => {        
        this.element.innerHTML = String(this.prefix);
        let value_text: string | number = this.currentValue;        
        if(this.format_as_currency) {
            value_text = Intl.NumberFormat("en-US", { style: 'currency', currency: 'USD'}).format(Number(value_text)).toString();
        } else if(this.number_format) {
            value_text = Number(value_text).toLocaleString(this.number_format);
        }
        this.element.innerHTML += (this.format_as_currency ? value_text : String(value_text)); 
        this.element.innerHTML += String(this.suffix);
    };
    run = () => {
        if(this.hasRun) { return; }
        this.interval = window.setInterval(this.transform, this.getSpeed()); 
        this.hasRun = true;
    };
    canRun = () => (window.scrollY + window.screen.availHeight) >= this.element.offsetTop;
    attemptRun = () => { if(this.canRun()) { this.run(); } };
    initialize = () => {
        if(this.delay_until_view) {
            window.document.addEventListener("scroll", this.attemptRun);
            this.attemptRun();
        } else {
            this.run();
        }
    };

    getSpeed = () => Math.abs(this.transitionTime / (this.max - this.min));

    interval: number = -1;
    step: number = 1;
    element: HTMLElement;
    min: number;
    max: number;
    transitionTime: number;
    currentValue: number;
    prefix: string;
    suffix: string;
    number_format: string;
    hasRun: boolean = false;
    delay_until_view: boolean;
    format_as_currency: boolean;
}

export const activate: (q: string) => GnpCounter[] = (querySelector) => {
    let counters: any[] = [];

    window.document.body.querySelectorAll(querySelector).forEach(e => {
        counters.push(new GnpCounter({ element: e as HTMLElement }));
    });

    return counters;
};

export default { GnpCounter, activate };